import { FC, useEffect } from 'react';

import { useAppDispatch } from '../../../../hooks';
import { HistorySelectors, loadWorkHistory } from '../../../../reducers/history';
import Table from '../Table';

const WorkCompleted: FC = () => {
    const { completedWork } = HistorySelectors();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(loadWorkHistory({}));
    }, []);

    return (
        <Table
            title="Work completed"
            subtitle="Here is a list of work completed by you in the last 30 days. Tap on each item to see the issues you got from Beehive."
            allRows={completedWork || []}
        />
    );
};

export default WorkCompleted;
